function incrementValue()
{
    var value = parseInt(document.getElementById('Quantity').value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    document.getElementById('Quantity').value = value;
}

function decrementValue()
{
    var value = parseInt(document.getElementById('Quantity').value, 10);
    value = isNaN(value) ? 0 : value;
  if(value > 0){
  	value--;
  }
    
    document.getElementById('Quantity').value = value;
}